import React, { FC, memo } from "react";
import { useTranslation } from "react-i18next";
import {
  TitleWeek,
  VertLine,
  WeekDate,
  Wrapper,
} from "./WeekComponents.styles";
import ManifestRow from "./ManifestRow";

interface WeekProps {
  weekKey: string;   // "YYYY-WW"
  weekRange: string; // "Nov 25 – Dec 1"
  manifests: any;    // Immutable List of manifest summaries
  units: string;
}

const Week: FC<WeekProps> = ({ weekKey, weekRange, manifests, units }) => {
  const { t } = useTranslation("common");
  const isFallback = weekKey === "0000-00";
  const weekNum = isFallback ? null : weekKey.split("-")[1].replace(/^0/, "");

  return (
    <Wrapper>
      <TitleWeek>
        {weekNum ? t("parcels.week", { numberWeek: weekNum }) : null}
        {weekNum && weekRange ? <VertLine>|</VertLine> : null}
        {weekRange ? <WeekDate>{weekRange}</WeekDate> : null}
      </TitleWeek>
      <div>
        {manifests.map((manifest: any) => (
          <ManifestRow
            units={units}
            key={manifest.get("id")}
            manifest={manifest}
          />
        ))}
      </div>
    </Wrapper>
  );
};

export default memo(Week);
